
<template>
	<div>
		<!-- 会费记录 -->
		<div class="infoBody">
			<!-- 特俗样式表格 -->
			<div class="infobody_body">
				<div class="table_head">
					<span>缴费金额</span>
					<p></p>
					<span>会员等级</span>
					<p></p>
					<span>缴费年度</span>
					<p></p>
					<span>缴费时间</span>
					<p></p>
					<span>开票状态</span>
					<p></p>
					<span>动作</span>
				</div>
				<div class="table_list" v-for="(item,index) in tableList" :key="index">
					<!-- <p>无数据</p> -->
					<div class="innerTable">
						{{item.date}}
					</div>
					<div class="innerTable">
						{{item.content}}
					</div>
					<div class="innerTable">
						{{item.content}}
					</div>
					<div class="innerTable btninner">
						{{item.application}}
					</div>
					<div class="innerTable">
						<p :style="{color:'#f2a419'}" v-if="item.status == '开票中'">开票中</p>
						<p :style="{color:'#fe6127'}" v-else-if="item.status == '已拒绝'">未采纳</p>
						<p :style="{color:'#4facfe'}" v-else-if="item.status == '未开票'">未开票</p>
						<p v-else>已开票</p>
					</div>
					<div class="innerTable btninner">
						<div v-if="item.sqlcol" v-for="(key,index) in item.sqlcol" :key="index">
							<div class="" v-if="key ==='详情'" @click="routerSet">
								{{key}}
							</div>
							<div class="" v-else>
								{{key}}
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableList: [{
						date: '',
						content: '',
						status: '已拒绝',
						application: '查看',
						sqlcol: ['详情', '发票申请']
					},
					{
						date: '',
						content: '',
						status: '开票中',
						application: '查看',
						sqlcol: ['详情', '下载发票']
					},
					{
						date: '',
						content: '',
						status: '已开票',
						application: '',
						sqlcol: []
					}, {
						date: '',
						content: '',
						status: '未开票',
						application: '',
						sqlcol: []
					}
				]
			}
		},
		computed:{
			
		},
		components:{
		},
		methods:{
			routerSet(){
				console.log('点击')
				this.$router.push('/mrecordetail')
			},
		}
	}
</script>

<style scoped>
	/* 信息变更内容主体 */
	.infoBody {
		display: flex;
		flex-flow: column;
		justify-content: flex-start;
		width: 100%;
		height: 100%;
	}

	/* 信心变更主题内容 */
	.infobody_body {
		width: 100%;
		min-height: 100px;
		height: auto;
		background-color: #f9f9f9;
	}

	.table_head {
		display: flex;
		height: 50px;
		line-height: 50px;
	}

	.table_head span {
		flex: 1;
		background-color: #dce0e6;
		font-weight: bold;
		font-size: 15px;
	}

	.table_head p {
		height: 50px;
		width: 2px;
	}

	.table_list {
		width: 100%;
		height: 50px;
		line-height: 50px;
		display: flex;
		border-bottom: 1px solid #e9e9e9;
	}

	.innerTable{
		font-size: 14px;
		flex: 1;
	}
	.btninner{
		cursor: pointer;
	}
	.innerTable:nth-of-type(4){
		color: #4facfe;
	}
	.innerTable:last-child{
		color: #000;
		display: flex;
		align-items: center;
		justify-content: space-evenly;
	}
</style>

